module.exports = __webpack_public_path__ + "img/section_bg2.57e20415.png";